import { useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Normalizes URL paths to lowercase on client-side
 */
export function useUrlNormalization() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const pathname = window.location.pathname;
    const lowerPath = pathname.toLowerCase();
    const isNotLowercase = pathname !== lowerPath;

    const isInternalNextJsPath = pathname.startsWith('/_next') || pathname.startsWith('/static');
    const isApiRoute = pathname.startsWith('/api');

    if (isNotLowercase && !isInternalNextJsPath && !isApiRoute) {
      const search = window.location.search;
      const correctedPath = lowerPath + search;
      void navigate({ to: correctedPath, replace: true });
    }
  }, [navigate]);
}
